export default function Logo() {
    return (
        <h2 className="uppercase text-title text-logo font-extrabold">
            Mantle
        </h2>
    );
}
